import React from 'react';
import TextField from './TextField';
import { Input, Select } from 'antd';

const AntFilterField = (props) => {
  const {
    field: Component = TextField,
    type,
    placeholder,
    onTypeChange = () => {},
    defaultValue = 'eq',
    options,
    ...rest
  } = props;

  const defaultOptions = [
    {
      value: 'eq',
      label: 'Equals',
    },
    {
      value: 'gt',
      label: 'Greater Than',
    },
    {
      value: 'lt',
      label: 'Less Than',
    },
  ];

  const selectAfter = (
    <Select
      className='min-w-28'
      defaultValue={defaultValue}
      value={type}
      onChange={onTypeChange}
      options={options || defaultOptions}
    />
  );

  return <Input placeholder={placeholder} addonAfter={type && selectAfter} {...rest} />;
};

export default AntFilterField;
